import React from 'react';
import Hero from '.././sections/Hero';
import Features from '.././sections/Features';
import SignupSection from '.././sections/signup';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <Features />
      <SignupSection />
    </>
  );
};

export default HomePage;
